import { useEffect, useState } from "react"
import { BuilderComponent, builder } from "@builder.io/react"
import BackupFooter from "./BackupFooter"

export default function Footer() {
  const [ notFound, setNotFound ] = useState( false )
  const [ content, setContent ] = useState( null )

  useEffect( () => {
    async function fetchContent() {
      const content = await builder
        .get( `sleep-site-footer`, {
          url: window.location.pathname
        })
        .promise()

      setContent( content )
      setNotFound( !content )
    }
    fetchContent()
  }, [] )

  if ( notFound ) return <BackupFooter />


  return (
    <BuilderComponent model="sleep-site-footer" content={content ?? undefined} />
  )
}